import React from "react"
import QuestionAndAnswer from "./components/QuestionAndAnswer"

const aboutUsData = [
  {
    question: "What is Jeetar?",
    answer:
      "Jeetar is a super app that serves as a digital one-stop-shop solution for people all over the world.  We are introducing a new way of living well and improving the quality of life on a daily basis. How do we achieve this? By making online shopping easier and having items delivered to your door in minutes. We have over 5,000 products in our stores in various cities and areas. Each time you need items, simply download the Jeetar app, sign up, and place an order, and your items will be delivered to your home directly from our stores.",
  },
  {
    question: "How does Jeetar work?",
    answer:
      "Jeetar mobile app requires new users to sign up, while registered users can always sign into their accounts on the app. Once a user signs-in, there are available product categories to shop from. These categories include JeetMart, JeetFood, JeetMed, JeetFill, JeetMall, and JeetLocal. Explore any of the categories to satisfy your everyday needs and wants",
  },
  {
    question: "What’s Jeetar’s Delivery Fee?",
    answer:
      "The delivery fee on every order is automatically calculated based on the distance of our stores to your address.",
  },
  {
    question: "What time of the day can Jeetar Deliver an item?",
    answer:
      "Our working hours are between 8:00am - 6:10pm daily. We do not confirm orders or deliver items once it’s past 6:10pm.",
  },
  {
    question: "Where does Jeetar Deliver?",
    answer: (
      <p className="text-lg leading-8 lg:leading-10 lg:text-2xl text-kGray">
        Not yet! We currently operate in Ibadan and Lagos. An expansion will be
        done soon. Check out our{" "}
        <a href="/#where-we-are" className="text-kBlue underline">
          delivery areas
        </a>
        .
      </p>
    ),
  },
  {
    question: "How Can I stay in touch?",
    answer: (
      <p className="text-lg leading-8 lg:leading-10 lg:text-2xl text-kGray">
        Keep yourself updated about new features, discounts and products by
        following us on{" "}
        <a href="#" className="text-kBlue underline">
          Instagram
        </a>
        ,{" "}
        <a href="#" className="text-kBlue underline">
          Twitter
        </a>
        ,{" "}
        <a href="#" className="text-kBlue underline">
          Facebook
        </a>
        ,{" "}
        <a href="#" className="text-kBlue underline">
          LinkedIn
        </a>{" "}
        and{" "}
        <a href="#" className="text-kBlue underline">
          YouTube
        </a>
        . You can also subscribe to our mailing list{" "}
        <a href="#" className="text-kBlue underline">
          here
        </a>
        .
      </p>
    ),
  },
];

const NewAboutUs = () => {
  return (
    <div className="px-[2rem] py-8 lg:pr-[12.25rem] lg:pb-[6.4rem] lg:pl-[12.1rem] lg:mt-[6.25rem]">
      <h1 className="text-kBlack text-[2rem] leading-[2rem] lg:text-[3.5rem] lg:leading-[4rem] font-bold mb-[3.75rem]">
        About us
      </h1>
      <h2 className="text-[1rem] leading-[1.5rem] mb-5 lg:text-[2rem] lg:leading-[2.4rem] text-k2Black font-semibold capitalize lg:mb-10">
        We'll keep this brief because you're busy.
      </h2>
      {aboutUsData.map((item) => (
        <QuestionAndAnswer {...item} />
      ))}
    </div>
  )
}

export default NewAboutUs
